import { useEffect, useState, useMemo, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

import {
  CHL00625,
  CHL00631,
  CHL00652,
  CHL00658,
  CHL00670,
  CHL00695,
  CHL00701,
  CHL00711,
  CHL00726,
  CHL00751,
  CHL00776,
  CHL00781,
  CHL00800,
  CHL00835,
  CHL00861,
  CHL00876,
  CHL00877,
  CHL00878,
  CHL00905,
  CHL00908,
  CHL00918,
  CHL00933,
  CHL00952,
  CHL00954,
  CHL00955,
  CHL00960,
  CHL00961,
  CHL00962,
  CHL00965,
  CHL00976,
  CHL00981,
  CHL00987,
  CHL01007,
  CHL01016,
  CHL01029,
  CHL01040,
  CHL01045,
  CHL01056,
  CHL01067,
  CHL01087,
  CHL01111,
  CHL01122,
  CHL01132,
  CHL01137,
  CHL01140,
  CHL01150,
  CHL01155,
  CHL01156,
  CHL01161,
  CHL01166,
  CHL01176,
  CHL01196,
  CHL01201,
  CHL01206,
  CHL01211,
  CHL01255,
  CHL01261,
  CHL01269,
  CHL01271,
  CHL01281,
  CHL01287,
  CHL01297,
  CHL01307,
  CHL01322,
  CHL01327,
  CHL01336,
  CHL01337,
  CHL01357,
  CHL01366,
  CHL01382,
  CHL01412,
  CHL01414,
  CHL01417,
  CHL01421,
  CHL04445,
  CHL04451,
  CHL04479,
  CHL04481,
  CHL04492,
  CHL04493,
  CHL04497,
  CHL04501,
  CHL04502,
  CHL04505,
  CHL04508,
  CHL04510,
  CHL04520,
  CHL04521,
  CHL04527,
  CHL04530,
  CHL04544,
  CHL04545,
  CHL04573,
  CHL04577,
  CHL04588,
  CHL04595,
  CHL04598,
  CHL04599,
  CHL04617,
  CHL04626,
  CHL04632,
  CHL04636,
  CHL04638,
  CHL04650,
  CHL04656,
  CHL04666,
  CHL04678,
  CHL04688,
  CHL04696,
  CHL04704,
  CHL06388,
  CHL06397,
  CHL06403,
  CHL06409,
  CHL06430,
  CHL06454,
  CHL06489,
  CHL06492,
  CHL06495,
  CHL06498,
  CHL06504,
  CHL06507,
  CHL06510,
  CHL06528,
  CHL06549,
  CHL06552,
  CHL06558,
  CHL06570,
  CHL06582,
  CHL06603,
  CHL06606,
  CHL06632,
  CHL06638,
  CHL06653,
  CHL06662,
  CHL06671,
  CHL06720,
  CHL06732,
  CHL06744,
  CHL06747,
  CHL06753,
  CHL06756,
  CHL06762,
  CHL06771,
  CHL06777,
  CHL06793,
  CHL06796,
  CHL06799,
  CHL06805,
  CHL06814,
  CHL06839,
} from "../../utilis/Projects";
import { useLocation, useNavigate } from "react-router-dom";

const PROJECTS = [
  {
    id: "prj-01",
    category: "Windows & Doors",
    cover: [CHL00670],
    images: [CHL00670, CHL00658, CHL00625, CHL00652, CHL00631, CHL00670],
  },
  {
    id: "prj-02",
    category: "Windows & Doors",
    cover: [CHL00695],
    images: [CHL00695, CHL00701, CHL00711, CHL00726, CHL00751, CHL00776],
  },
  {
    id: "prj-03",
    category: "Windows & Doors",
    cover: [CHL00781],
    images: [
      CHL00781,
      CHL00800,
      CHL00861,
      CHL00861,
      CHL00878,
      CHL00908,
      CHL00918,
      CHL00933,
      CHL00905,
    ],
  },
  {
    id: "prj-04",
    category: "Railings",
    cover: [CHL00962],
    images: [CHL00962, CHL00960, CHL00961],
  },
  {
    id: "prj-05",
    category: "Windows & Doors",
    cover: [CHL00835],
    images: [CHL00835, CHL00876, CHL00877],
  },
  {
    id: "prj-06",
    category: "Windows & Doors",
    cover: [CHL00955],
    images: [CHL00955, CHL00954, CHL00952],
  },
  {
    id: "prj-07",
    category: "Louvers",
    cover: [CHL01269],
    images: [CHL01269, CHL01261, CHL06805, CHL06839],
  },
  {
    id: "prj-08",
    category: "Railings",
    cover: [CHL01337],
    images: [CHL01337, CHL01357, CHL01366],
  },
  {
    id: "prj-09",
    category: "Windows & Doors",
    cover: [CHL00965],
    images: [CHL00965, CHL00981, CHL00987, CHL01007, CHL01016, CHL00976],
  },
  {
    id: "prj-10",
    category: "Louvers",
    cover: [CHL01271],
    images: [CHL01271, CHL06653, CHL06777],
  },
  {
    id: "prj-11",
    category: "Windows & Doors",
    cover: [CHL01045],
    images: [CHL01045, CHL01056, CHL01067, CHL01029, CHL01040],
  },
  {
    id: "prj-12",
    category: "Windows & Doors",
    cover: [CHL01150],
    images: [
      CHL01150,
      CHL01087,
      CHL01111,
      CHL01122,
      CHL01132,
      CHL01137,
      CHL01140,
    ],
  },
  {
    id: "prj-13",
    category: "Windows & Doors",
    cover: [CHL01201],
    images: [
      CHL01201,
      CHL01155,
      CHL01156,
      CHL01161,
      CHL01166,
      CHL01176,
      CHL01196,
      CHL01201,
      CHL01206,
      CHL01211,
      CHL01255,
    ],
  },
  {
    id: "prj-14",
    category: "Windows & Doors",
    cover: [CHL01287],
    images: [CHL01287, CHL01281],
  },
  {
    id: "prj-15",
    category: "Windows & Doors",
    cover: [CHL01297],
    images: [CHL01297, CHL01307, CHL01322, CHL01327, CHL01336],
  },
  {
    id: "prj-16",
    category: "Windows & Doors",
    cover: [CHL01382],
    images: [CHL01382, CHL01412, CHL01414],
  },
  {
    id: "prj-17",
    category: "Railings",
    cover: [CHL01417],
    images: [CHL01417, CHL01421],
  },
  {
    id: "prj-18",
    category: "Windows & Doors",
    cover: [CHL04445],
    images: [CHL04445, CHL04451],
  },
  {
    id: "prj-19",
    category: "Windows & Doors",
    cover: [CHL04479],
    images: [CHL04479, CHL04481, CHL04497, CHL04501, CHL04502],
  },
  {
    id: "prj-20",
    category: "Windows & Doors",
    cover: [CHL04493],
    images: [
      CHL04493,
      CHL04492,
      CHL04505,
      CHL04508,
      CHL04510,
      CHL04520,
      CHL04521,
    ],
  },
  {
    id: "prj-21",
    category: "Windows & Doors",
    cover: [CHL04527],
    images: [
      CHL04527,
      CHL04530,
      CHL04577,
      CHL04544,
      CHL04545,
      CHL04573,
      CHL04588,
      CHL04595,
    ],
  },
  {
    id: "prj-22",
    category: "Windows & Doors",
    cover: [CHL04598],
    images: [CHL04598, CHL04599, CHL04617],
  },
  {
    id: "prj-23",
    category: "Windows & Doors",
    cover: [CHL04656],
    images: [
      CHL04656,
      CHL04626,
      CHL04638,
      CHL04650,
      CHL04656,
      CHL04666,
      CHL04688,
      CHL04696,
      CHL04704,
    ],
  },
  {
    id: "prj-24",
    category: "Railings",
    cover: [CHL04632],
    images: [CHL04632, CHL04636, CHL04678],
  },
  {
    id: "prj-25",
    category: "Windows & Doors",
    cover: [CHL06839],
    images: [CHL06839, CHL06814, CHL06805],
  },
  {
    id: "prj-26",
    category: "Windows & Doors",
    cover: [CHL06793],
    images: [CHL06793, CHL06796, CHL06799],
  },
  {
    id: "prj-27",
    category: "Windows & Doors",
    cover: [CHL06403],
    images: [CHL06403, CHL06388, CHL06397, CHL06409],
  },
  {
    id: "prj-28",
    category: "Windows & Doors",
    cover: [CHL06489],
    images: [CHL06489, CHL06492, CHL06495, CHL06454],
  },
  {
    id: "prj-29",
    category: "Louvers",
    cover: [CHL06558],
    images: [CHL06558, CHL06430],
  },
  {
    id: "prj-30",
    category: "Windows & Doors",
    cover: [CHL06528],
    images: [CHL06528, CHL06498, CHL06510, CHL06552, CHL06549],
  },
  {
    id: "prj-31",
    category: "Windows & Doors",
    cover: [CHL06570],
    images: [CHL06570, CHL06582, CHL06603, CHL06606, CHL06632],
  },
  {
    id: "prj-32",
    category: "Windows & Doors",
    cover: [CHL06671],
    images: [CHL06671, CHL06638, CHL06662],
  },
  {
    id: "prj-33",
    category: "Windows & Doors",
    cover: [CHL06753],
    images: [CHL06753, CHL06747, CHL06720, CHL06732, CHL06744],
  },
  {
    id: "prj-34",
    category: "Windows & Doors",
    cover: [CHL06771],
    images: [CHL06771, CHL06756, CHL06762],
  },
  {
    id: "prj-35",
    category: "Railings",
    cover: [CHL06504],
    images: [CHL06504, CHL06507],
  },
];

const CATS = ["Louvers", "Railings", "Windows & Doors", "All"];

export default function Projects() {
  const [cat, setCat] = useState("Louvers");
  const [open, setOpen] = useState(null);
  const [slide, setSlide] = useState(0);
  const scrollY = useRef(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isProjectPage = location.pathname.includes("/projects");
  const sectionRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(
    isProjectPage ? PROJECTS.length : 12
  );

  const filtered = useMemo(
    () => PROJECTS.filter((p) => cat === "All" || p.category === cat),
    [cat]
  );
  useEffect(() => {
    if (isProjectPage) {
      const timeout = setTimeout(() => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 800);

      return () => clearTimeout(timeout);
    }
  }, [isProjectPage]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(null);
      if (e.key === "ArrowRight") setSlide((s) => (s + 1) % open.images.length);
      if (e.key === "ArrowLeft")
        setSlide((s) => (s - 1 + open.images.length) % open.images.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;

    if (open) {
      scrollY.current = window.scrollY;

      body.style.position = "fixed";
      body.style.top = `-${scrollY.current}px`;
      body.style.width = "100%";
      body.style.overflowY = "hidden";
      html.style.overflow = "hidden";
    } else {
      const y = scrollY.current;
      body.style.position = "";
      body.style.top = "";
      body.style.width = "";
      body.style.overflowY = "";
      html.style.overflow = "";

      window.scrollTo({ top: y });
    }

    return () => {
      body.style.position = "";
      body.style.top = "";
      body.style.width = "";
      body.style.overflowY = "";
      html.style.overflow = "";
    };
  }, [open]);

  return (
    <section
      id="projects"
      ref={sectionRef}
      className="relative container bg-transparent scroll-mt-24"
    >
      <div className="w-full py-10">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6">
          Projects
        </h2>

        <div className="flex flex-wrap gap-3 mb-8">
          {CATS.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={`px-4 py-2 rounded-md text-sm border transition-all ${
                cat === c
                  ? "bg-white text-black border-white"
                  : "border-white/30 text-white/80 hover:bg-white/10"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="columns-2 xs:columns-2 sm:columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
          {filtered.slice(0, visibleCount).map((p) => (
            <motion.div
              key={p.id}
              layout
              onClick={() => {
                setOpen(p);
                setSlide(0);
              }}
              className="relative break-inside-avoid overflow-hidden border border-white/10 cursor-pointer group"
            >
              <img
                src={p.cover[0]}
                alt={p.title}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col items-center justify-center text-center p-4">
                <p className="text-white/80 text-sm">{p.category}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {!isProjectPage && (
          <div className="text-start mt-5">
            <button
              onClick={() => navigate("/projects")}
              className="px-6 py-3 bg-white text-black font-semibold rounded-md hover:bg-gray-200 transition-all duration-300"
            >
              + Read More
            </button>
          </div>
        )}
      </div>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              className="fixed inset-0 z-50 bg-black/90"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setOpen(null)}
            />

            <motion.div
              className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <div className="relative w-full max-w-6xl gap-6">
                <div className="overflow-hidden border border-white/10 bg-black">
                  <div className="relative h-[55vh] md:h-[70vh] flex items-center justify-center">
                    <AnimatePresence mode="wait">
                      {!imageLoaded && (
                        <div
                          role="status"
                          className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center absolute inset-0 justify-center"
                        >
                          <div className="flex items-center justify-center w-full h-full bg-gray-700/60 rounded-sm">
                            <svg
                              className="w-16 h-16 text-gray-500"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 18"
                            >
                              <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                            </svg>
                          </div>
                        </div>
                      )}
                      <motion.img
                        key={open.images[slide]}
                        src={open.images[slide]}
                        alt={open.title}
                        className="absolute inset-0 w-full h-full object-contain bg-black"
                        initial={{ opacity: 0, scale: 1.03 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.45 }}
                        onLoad={() => setImageLoaded(true)}
                        onError={() => setImageLoaded(true)}
                      />
                    </AnimatePresence>
                    <button
                      onClick={() => setOpen(null)}
                      className="absolute top-3 right-3 z-20 bg-black/60 hover:bg-white/20 text-white rounded-full h-9 w-9 flex items-center justify-center transition-all duration-300"
                    >
                      ✕
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setImageLoaded(false);
                        setSlide(
                          (s) =>
                            (s - 1 + open.images.length) % open.images.length
                        );
                      }}
                      className="absolute left-3 top-1/2 -translate-y-1/2 bg-black hover:bg-white/20 text-white rounded-full h-9 w-9 flex items-center justify-center"
                    >
                      ‹
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setImageLoaded(false);
                        setSlide((s) => (s + 1) % open.images.length);
                      }}
                      className="absolute right-3 top-1/2 -translate-y-1/2 bg-black hover:bg-white/20 text-white rounded-full h-9 w-9 flex items-center justify-center"
                    >
                      ›
                    </button>
                  </div>
                </div>

                {/* <div className="md:col-span-4 border border-white/10 bg-white/[0.05] p-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <div className="text-xs uppercase text-white/70 tracking-widest">
                        {open.category}
                      </div>
                      <h3 className="mt-2 text-2xl font-bold text-white">
                        {open.title}
                      </h3>
                    </div>
                    <button
                      onClick={() => setOpen(null)}
                      className="text-white/80 hover:text-white"
                    >
                      ✕
                    </button>
                  </div>
                  <p className="mt-3 text-white/80 leading-relaxed">
                    {open.blurb}
                  </p>
                  <div className="mt-5 grid grid-cols-2 gap-3 text-sm text-white/80">
                    <div className="border border-white/10 bg-white/[0.05] px-3 py-2 rounded">
                      <div className="text-[11px] uppercase text-white/50">
                        Location
                      </div>
                      {open.location}
                    </div>
                    <div className="border border-white/10 bg-white/[0.05] px-3 py-2 rounded">
                      <div className="text-[11px] uppercase text-white/50">
                        Year
                      </div>
                      {open.year}
                    </div>
                    <div className="col-span-2 border border-white/10 bg-white/[0.05] px-3 py-2 rounded">
                      <div className="text-[11px] uppercase text-white/50">
                        Area
                      </div>
                      {open.area}
                    </div>
                  </div>
                </div> */}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </section>
  );
}
